export default __webpack_public_path__ + "static/media/background_header.8c37bd60.jpg";